import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import Img from 'gatsby-image'

import { Facebook, Twitter, Instagram } from '../index'

import styles from './Footer.module.sass'

const getFooter = graphql`
  query Footer {
    allContentfulCategories {
      nodes {
        Slug
        Title
        id
      }
    }
    mushrooms: file(relativePath: { regex: "/mushrooms/" }) {
      childImageSharp {
        fluid(maxWidth: 200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(getFooter)
  return (
    <footer className={styles.footer}>
      <div className="navContainer">
        <div className={styles.footerTop}>
          <div className={styles.footerLinksContainer}>
            <div className={styles.footerLinksHeader}>
              <h3>
                <span className="bold">Links</span>
              </h3>
            </div>
            <div className={styles.footerLinks}>
              <ul>
                <Link to="/" className={styles.footerLink}>
                  Home
                </Link>
                <Link to="/about" className={styles.footerLink}>
                  About
                </Link>
                <Link to="/contact" className={styles.footerLink}>
                  Contact
                </Link>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.etsy.com/uk/shop/FairiesofTranquility#reviews"
                  className={styles.footerLink}
                >
                  Reviews
                </a>
                <Link to="/privacy" className={styles.footerLink}>
                  Privacy Policy
                </Link>
                <Link to="/shipping" className={styles.footerLink}>
                  Shipping & Returns
                </Link>
                <Link to="/terms" className={styles.footerLink}>
                  Terms & Conditions
                </Link>
              </ul>
              <ul>
                <Link to="/shop" className={styles.footerLink}>
                  <span className="bold">Shop</span>
                </Link>
                {data.allContentfulCategories.nodes.map(link => {
                  return (
                    <Link
                      to={`/shop/${link.Slug}`}
                      className={styles.footerLink}
                      key={link.id}
                    >
                      {link.Title}
                    </Link>
                  )
                })}
              </ul>
            </div>
          </div>
          <div className={styles.footerImageContainer}>
            <Img
              className={styles.footerImage}
              fluid={data.mushrooms.childImageSharp.fluid}
            />
          </div>
        </div>
      </div>
      <div className="navContainer">
        <div className={styles.footerBottom}>
          <div className={styles.footerSVG}>
            <a
              rel="noreferrer"
              href="https://www.facebook.com/FairiesofTranquility/"
              target="_blank"
            >
              <Facebook />
            </a>
            <a
              rel="noreferrer"
              href="https://twitter.com/fairytranquil?lang=en"
              target="_blank"
            >
              <Twitter />
            </a>
            <a
              rel="noreferrer"
              href="https://www.instagram.com/fairiesoftranquility/"
              target="_blank"
            >
              <Instagram />
            </a>
          </div>
          <p className="small">
            &copy; Fairies of Tranquility - Est. 2016 - All Rights Reserved.
          </p>
          <p className="small">England, 01379 788301</p>

          <p className="small">
            Designed & Developed by
            <a href="https://www.aaronduke.co.uk/" className="smallfooter">
              {' '}
              Aaron Duke
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
